import { WidgetActionMethod } from '../../WidgetVariant';

enum FloatingActionCardActionMethod {
  Hide = 'hide',
  Show = 'show',
  DisplayButton = 'DisplayButton',
  DisplayCard = 'DisplayCard',
  DisplayWindow = 'DisplayWindow',
  InitiateSimplrChat = 'initiateSimplrChat',
  InitiateChat = 'initiateChat',
}

export type ActionMethod = FloatingActionCardActionMethod | WidgetActionMethod;

export const ActionMethod = {
  ...FloatingActionCardActionMethod,
  ...WidgetActionMethod,
};
